var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 808,
    height: 609,
    viewBox: "0 0 808 609",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M722.813 413.548C693.827 469.54 641.48 527.576 576.32 538.704C477.92 555.538 457.253 630.888 288.04 602.993C263.32 599.038 239.103 592.404 215.813 583.207C204.441 578.673 193.37 573.417 182.667 567.469C88.2134 515.017 47.1601 419.947 54.1467 326.561C63.3067 203.729 155.48 155.887 214.84 128.552C274.2 101.218 356.88 -22.7495 523.44 3.32921C548.887 7.21189 573.803 14.0215 597.693 23.623C652.12 45.7472 705.227 86.4818 732.467 139.855C734.52 143.872 736.445 147.951 738.24 152.093C773.547 233.188 762.333 337.209 722.813 413.548Z",
    fill: "url(#paint0_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M722.813 413.548C693.827 469.54 641.48 527.576 576.32 538.704C477.92 555.538 457.253 630.888 288.04 602.993C263.32 599.038 239.103 592.404 215.813 583.207C204.441 578.673 193.37 573.417 182.667 567.469C88.2134 515.017 47.1601 419.947 54.1467 326.561C63.3067 203.729 155.48 155.887 214.84 128.552C274.2 101.218 356.88 -22.7495 523.44 3.32921C548.887 7.21189 573.803 14.0215 597.693 23.623C652.12 45.7472 705.227 86.4818 732.467 139.855C734.52 143.872 736.445 147.951 738.24 152.093C773.547 233.188 762.333 337.209 722.813 413.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 60.0023L63.8667 75.6602H330.267L337.613 60.0023H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 75.1793L63.8667 90.8372H330.267L337.613 75.1793H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 90.3562L63.8667 106.014H330.267L337.613 90.3562H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 105.533L63.8667 121.191H330.267L337.613 105.533H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 120.71L63.8667 136.368H330.267L337.613 120.71H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 135.887L63.8667 151.558H330.267L337.613 135.887H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 151.064L63.8667 166.722H330.267L337.613 151.064H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 166.241L63.8667 181.912H330.267L337.613 166.241H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 181.418L63.8667 197.076H330.267L337.613 181.418H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 196.595L63.8667 212.266H330.267L337.613 196.595H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 211.772L63.8667 227.43H330.267L337.613 211.772H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 226.949L63.8667 242.62H330.267L337.613 226.949H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 242.126L63.8667 257.784H330.267L337.613 242.126H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 257.303L63.8667 272.974H330.267L337.613 257.303H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 272.48L63.8667 288.151H330.267L337.613 272.48H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 287.657L63.8667 303.328H330.267L337.613 287.657H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 302.834L63.8667 318.505H330.267L337.613 302.834H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 318.011L63.8667 333.682H330.267L337.613 318.011H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 333.188L63.8667 348.859H330.267L337.613 333.188H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 348.365L63.8667 364.036H330.267L337.613 348.365H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 363.542L63.8667 379.213H330.267L337.613 363.542H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 378.718L63.8667 394.39H330.267L337.613 378.718H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 393.895L63.8667 409.567H330.267L337.613 393.895H73.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.613 60.0023V409.794H330.267",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 60.0023L349.027 75.6602H615.427L622.76 60.0023H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 75.1793L349.027 90.8372H615.427L622.76 75.1793H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 90.3562L349.027 106.014H615.427L622.76 90.3562H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 105.533L349.027 121.191H615.427L622.76 105.533H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 120.71L349.027 136.368H615.427L622.76 120.71H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 135.887L349.027 151.558H615.427L622.76 135.887H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 151.064L349.027 166.722H615.427L622.76 151.064H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 166.241L349.027 181.912H615.427L622.76 166.241H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 181.418L349.027 197.076H615.427L622.76 181.418H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 196.595L349.027 212.266H615.427L622.76 196.595H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 211.772L349.027 227.43H615.427L622.76 211.772H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 226.949L349.027 242.62H615.427L622.76 226.949H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 242.126L349.027 257.784H615.427L622.76 242.126H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 257.303L349.027 272.974H615.427L622.76 257.303H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 272.48L349.027 288.151H615.427L622.76 272.48H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 287.657L349.027 303.328H615.427L622.76 287.657H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 302.834L349.027 318.505H615.427L622.76 302.834H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 318.011L349.027 333.682H615.427L622.76 318.011H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 333.188L349.027 348.859H615.427L622.76 333.188H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 348.365L349.027 364.036H615.427L622.76 348.365H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 363.542L349.027 379.213H615.427L622.76 363.542H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 378.718L349.027 394.39H615.427L622.76 378.718H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.96 393.895L349.027 409.567H615.427L622.76 393.895H358.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.76 60.0023V409.794H615.427",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.4 203.956C634.4 203.956 631.107 213.054 624.08 214.297C617.053 215.539 604.693 201.886 612.533 194.858C620.373 187.831 631.107 199 634.4 203.956Z",
    fill: "url(#paint1_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.133 159.294C645.133 159.294 634.813 184.518 638.947 196.929C643.08 209.34 668.653 218.425 676.08 202.273C683.507 186.121 667 163.409 660.813 158.439C654.627 153.469 647.2 155.166 645.133 159.294Z",
    fill: "url(#paint2_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.333 170.049C705.333 170.049 687.587 186.174 685.52 202.3C683.453 218.425 695.427 224.223 707.813 222.153C720.2 220.082 726.373 188.659 722.667 174.19C718.96 159.721 705.333 170.049 705.333 170.049Z",
    fill: "url(#paint3_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.693 259.374C708.693 259.374 688.88 260.202 688.053 269.701C687.227 279.2 696.72 281.284 706.213 273.014C715.707 264.744 716.947 259.788 708.693 259.374Z",
    fill: "url(#paint4_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.573 279.28C659.573 279.28 657.52 289.206 650.08 292.934C642.64 296.661 629.453 288.792 636.467 276.808C643.48 264.824 655.867 274.257 659.573 279.28Z",
    fill: "url(#paint5_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.24 248.205C642.24 248.205 638.533 239.935 624.08 245.306C609.627 250.676 603.867 258.959 612.947 261.912C622.027 264.865 642.24 248.205 642.24 248.205Z",
    fill: "url(#paint6_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.507 148.967C683.507 148.967 685.987 154.751 690.947 153.509C695.907 152.266 697.133 144.825 704.973 146.829C712.813 148.833 719.413 157.985 719.413 153.856C719.413 149.728 709.507 139 698.373 139C687.24 139 683.92 143.582 683.507 148.967Z",
    fill: "url(#paint7_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.093 211.425C663.093 211.425 671.733 236.809 673.587 258.385C675.44 279.961 673.587 314.604 673.587 314.604",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.333 220.068C693.333 220.068 683.467 249.113 681 267.643C678.533 286.174 677.907 314.604 677.907 314.604",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.387 271.972C688.387 271.972 684.067 273.215 681.6 315.218",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.573 279.28C659.573 279.28 663.72 275.753 666.24 283.782C668.76 291.812 667.467 314.056 667.467 314.056",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.253 275.272C673.48 293.388 670.493 313.415 670.493 313.415",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.24 248.205C642.24 248.205 660 244.784 667.413 264.584C668.155 266.561 668.774 268.582 669.267 270.636",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.4 229.046C716.4 229.046 720.12 220.777 734.56 226.161C749 231.545 754.787 239.801 745.707 242.7C736.627 245.599 716.4 229.046 716.4 229.046Z",
    fill: "url(#paint8_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.613 232.667C696.248 235.827 692.983 240.28 691.28 245.399C683.88 265.172 684.72 313.989 684.72 313.989",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.4 229.046C712.226 228.459 707.971 229.041 704.107 230.73",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.867 216.568C658.496 222.179 662.045 228.603 664.333 235.513C674.2 263.943 677.893 300.402 676.053 313.989",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.4 203.956C634.4 203.956 643.013 205.292 651.733 214.217",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.92 243.208C678.32 279.08 677.893 314.644 677.893 314.644",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.507 148.967C683.507 148.967 681.6 147.163 680.36 179.294C679.88 191.772 679.4 214.992 679.027 238.706",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.667 377.636H659.507C657.636 377.635 655.833 376.937 654.448 375.678C653.063 374.418 652.195 372.688 652.013 370.823L646.453 313.375H708.733L703.16 370.823C702.978 372.688 702.11 374.418 700.725 375.678C699.34 376.937 697.537 377.635 695.667 377.636Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.307 332.533L648.96 339.32H706.213L706.867 332.533H648.307Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.773 354.149L705.133 350.449H650.04L650.4 354.149H704.773Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.093 329.433C702.818 329.433 705.027 327.22 705.027 324.49C705.027 321.76 702.818 319.547 700.093 319.547C697.369 319.547 695.16 321.76 695.16 324.49C695.16 327.22 697.369 329.433 700.093 329.433Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.693 329.433C658.418 329.433 660.627 327.22 660.627 324.49C660.627 321.76 658.418 319.547 655.693 319.547C652.969 319.547 650.76 321.76 650.76 324.49C650.76 327.22 652.969 329.433 655.693 329.433Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.56 324.49C665.56 325.468 665.849 326.424 666.391 327.237C666.933 328.049 667.704 328.683 668.605 329.057C669.507 329.431 670.499 329.529 671.456 329.338C672.413 329.148 673.292 328.677 673.982 327.986C674.672 327.294 675.141 326.413 675.332 325.455C675.522 324.496 675.424 323.502 675.051 322.599C674.678 321.695 674.045 320.923 673.234 320.38C672.423 319.837 671.469 319.547 670.493 319.547C669.185 319.547 667.93 320.068 667.005 320.995C666.08 321.922 665.56 323.179 665.56 324.49Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.293 329.433C688.018 329.433 690.227 327.22 690.227 324.49C690.227 321.76 688.018 319.547 685.293 319.547C682.569 319.547 680.36 321.76 680.36 324.49C680.36 327.22 682.569 329.433 685.293 329.433Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M606.36 238.425L605.667 238.185L606.107 232.921C606.117 232.752 606.065 232.585 605.96 232.453C605.906 232.387 605.839 232.333 605.763 232.294C605.688 232.255 605.605 232.232 605.52 232.226L493.933 222.74C493.847 222.733 493.759 222.744 493.677 222.771C493.594 222.799 493.518 222.843 493.453 222.901C493.328 223.011 493.247 223.163 493.227 223.328L488.4 280.349C482.093 276.074 469.16 268.325 457.027 261.324C455.493 258.799 454.28 256.875 453.68 255.98C452.49 254.359 451.081 252.911 449.493 251.678C450.325 251.149 451.079 250.506 451.733 249.768C456.067 244.424 460.56 233.95 460.733 233.535L462.333 230.195C463.56 230.791 464.903 231.11 466.267 231.131C467.403 231.167 468.523 230.844 469.467 230.209C472.6 227.911 480.813 212.52 477.013 207.069C476.699 206.592 476.282 206.192 475.793 205.898C475.304 205.604 474.755 205.425 474.187 205.372L477.893 197.597C482.887 198.645 487.935 199.416 493.013 199.908C507.32 200.99 514.853 201.338 518.84 201.338C523.213 201.338 523.293 200.924 523.36 200.616C523.427 200.309 523.187 199.868 522.6 199.681C519.707 198.706 497.173 186.094 493.987 183.435C491.501 181.165 489.196 178.704 487.093 176.074C487.667 171.104 491.213 138.225 486.64 133.389C481.747 128.218 437.573 111.906 431.173 110.957C424.44 109.955 414.28 113.629 410.667 118.359L410.587 118.506C407.92 124.758 404.52 132.467 401.507 139.2C397.707 147.711 395.253 152.894 394.24 154.604C394.24 154.604 394.24 154.671 394.24 154.711C394.173 154.824 394.098 154.932 394.013 155.032C392.107 156.194 356.973 160.269 353.587 160.269C352.613 160.269 352.44 160.817 352.413 161.057C352.16 163.101 364.413 169.073 391.773 176.648C391.48 178.813 391.067 181.872 390.6 185.346C385.8 184.451 382.72 184.518 381.267 185.546C380.978 185.742 380.736 185.999 380.559 186.299C380.381 186.6 380.272 186.936 380.24 187.283C380.165 189.385 380.533 191.479 381.32 193.429C381.32 194.551 381.48 202.139 383.853 205.84C384.794 207.196 386.018 208.331 387.44 209.167C387.32 210.089 387.213 210.944 387.12 211.692C386.412 218.471 386.363 225.304 386.973 232.092L379.093 230.449C379.001 230.429 378.905 230.429 378.813 230.449C378.813 230.449 378.813 230.449 378.733 230.449C378.694 230.442 378.653 230.442 378.613 230.449L376.4 232.133L362.133 227.363C362.021 227.329 361.902 227.325 361.787 227.35C361.673 227.376 361.567 227.431 361.48 227.51L351.187 237.557C351.07 237.676 350.999 237.832 350.987 237.998L350.84 242.006L321.507 250.583C305.587 254.591 289 259.213 288.4 261.418C287.453 264.865 283.693 296.367 283.56 298.826C282.074 300.627 280.484 302.34 278.8 303.956C271.013 311.878 264.613 318.652 265.28 321.591C266.173 325.479 270.307 339.868 270.987 342.219C269.187 344.717 256.387 362.954 259.893 369.34C264.133 377.075 272.013 390.849 277 396.167C281.147 400.589 284.76 402.566 289 402.566C290.234 402.555 291.463 402.411 292.667 402.139C293.36 401.978 296.053 401.604 300.24 401.056L270.293 551.049C270.273 551.143 270.274 551.241 270.297 551.334C270.32 551.427 270.364 551.514 270.426 551.588C270.488 551.661 270.566 551.72 270.654 551.758C270.742 551.797 270.837 551.815 270.933 551.811H486.253C486.337 551.811 486.421 551.794 486.498 551.762C486.576 551.73 486.647 551.683 486.707 551.624C486.77 551.564 486.82 551.492 486.852 551.411C486.885 551.33 486.899 551.243 486.893 551.156L483.653 417.289C487.042 422.318 490.997 426.94 495.44 431.063C506.88 441.577 518.467 450.943 518.573 451.036C518.692 451.126 518.838 451.173 518.987 451.17C519.071 451.171 519.154 451.155 519.232 451.122C519.31 451.09 519.381 451.043 519.44 450.983L519.72 450.702C526.145 444.034 531.514 436.42 535.64 428.124C535.84 427.723 536.027 427.322 536.213 426.908C540.053 426.614 543.533 426.2 544.213 426.106L545.613 426.467C546.533 429.326 547.307 431.237 547.827 431.49C549.353 432.073 550.981 432.341 552.613 432.279C554.163 432.33 555.709 432.094 557.173 431.584C558.757 431.918 560.368 432.101 561.987 432.132C563.264 432.259 564.544 431.928 565.6 431.197C566.866 432.211 568.39 432.849 570 433.04C570.411 433.047 570.818 432.955 571.187 432.773C572.267 432.239 573.96 428.765 575.547 424.757C576.173 427.67 577.347 432.492 578.707 434.537C579.09 435.152 579.625 435.658 580.26 436.007C580.895 436.355 581.609 436.534 582.333 436.527H582.667C583.465 436.491 584.241 436.256 584.926 435.843C585.61 435.43 586.181 434.852 586.587 434.162C587.693 431.931 585.573 414.844 584.987 413.655C584.4 412.466 581.187 411.517 579.653 411.17C579.84 405.826 570.72 402.566 569.387 402.125C567.72 400.282 558.107 395.766 555.92 394.737C554.667 393.561 545.907 386.334 543.187 385.652C540.467 384.971 537.053 386.213 534.56 388.725C534.498 388.783 534.449 388.853 534.417 388.932C534.385 389.01 534.37 389.095 534.373 389.179C533.62 389.707 532.923 390.311 532.293 390.983C532.093 391.21 531.84 391.464 531.573 391.731C529.01 389.881 526.59 387.84 524.333 385.626C523.161 384.029 521.82 382.564 520.333 381.257C520.413 380.95 520.547 380.509 520.693 379.988L592.48 386.093C592.641 386.094 592.796 386.034 592.915 385.925C593.033 385.816 593.106 385.666 593.12 385.505L600.84 294.27L602.466 293.615C603.195 293.343 603.833 292.871 604.305 292.251C604.776 291.632 605.064 290.891 605.133 290.115L609.133 242.78C609.229 241.847 609.008 240.909 608.504 240.118C608.001 239.328 607.245 238.731 606.36 238.425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.973 274.991L444.16 360.295C444.16 360.295 452.44 360.629 452.773 362.62C453.107 364.61 449.8 375.9 449.8 375.9C451.384 377.299 452.827 378.852 454.107 380.535C455.093 382.152 469.333 392.84 469.333 392.84C469.333 392.84 474.667 398.184 469 415.739C463.333 433.294 449.12 447.269 449.12 447.269C449.12 447.269 437.2 437.649 425.267 426.694C418.02 419.984 412.068 411.996 407.707 403.127C407.707 403.127 402.747 351.344 403.08 344.704C403.413 338.064 420.973 274.991 420.973 274.991Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.987 387.95C426.24 382.125 432.253 374.336 434.893 372.907C439.2 370.582 446.813 375.232 446.813 375.232",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.333 394.483C417.333 394.483 418.667 392.626 420.507 389.994",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.867 361.952C438.867 361.952 426.613 361.618 420.64 370.248",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.013 415.726C474.667 398.184 469.333 392.84 469.333 392.84L466.453 390.676L465.68 391.17C465.68 391.17 448.787 394.497 442.827 400.135C436.867 405.772 434.547 419.052 437.853 425.358C441.16 431.664 449.12 447.269 449.12 447.269C450.133 446.28 463.573 432.693 469.013 415.726Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.187 231.505L226.853 247.109L231.493 358.304L193.067 551.143H415.347L410.373 345.399C410.373 345.399 421.307 277.022 421.04 275.032C420.773 273.041 370.373 244.157 370.373 244.157C370.373 244.157 306.667 225.533 280.187 231.505Z",
    fill: "url(#paint9_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.493 551.143L210.64 462.993L193.067 551.143H289.493Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.893 531.517L317.933 548.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.24 390.729L320.933 522.539",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.147 263.702L419.32 280.295L417.333 272.667L390.827 256.408",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.013 222.714L286.92 217.664L276.253 228.031L274.293 282.126L308.693 285.76C308.693 285.76 280.16 313.508 284.693 319.16C289.227 324.811 316.013 350.823 334.48 360.068C352.947 369.313 348.187 367.643 348.187 367.643L354.667 349.941C354.667 349.941 312.427 242.046 312.16 241.204C311.893 240.362 302.013 222.714 302.013 222.714Z",
    fill: "url(#paint10_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.667 349.941L338.16 385.813C338.16 385.813 363.893 368.164 383.76 345.452C403.627 322.74 408.64 312.667 406.427 307.349C404.213 302.032 381.253 286.04 381.253 286.04C381.253 286.04 401.667 288.565 403.347 287.443C405.027 286.321 385.333 252.974 381.173 246.815C377.013 240.656 363.267 233.923 363.267 233.923C363.267 233.923 370.267 305.666 354.667 349.941Z",
    fill: "url(#paint11_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.32 452.746V425.826L410.373 345.359C410.373 345.359 421.307 276.982 421.04 274.991C420.84 273.762 401.653 262.34 386.947 253.736C382.12 250.917 374.227 235.286 372.2 243.248L359.027 318.064L337.693 378.772L273.92 310.81L224.84 391.718L224.32 394.283L412.32 452.746Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.533 220.75L317.96 223.555L341.173 264.971C341.173 264.971 309.013 232.239 304.533 220.75Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.307 227.75C295.307 227.75 302.293 260.269 320.76 290.249C339.227 320.228 355.72 344.063 355.72 344.063C355.72 344.063 372.493 310.983 373.613 297.53C374.733 284.076 373.613 263.342 373.613 263.342L295.307 227.75Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.693 282.967L351.8 299.494L345.653 318.558L354.88 335.646L366.627 312.947L358.52 296.701L368.027 280.723L353.2 268.392L336.693 282.967Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.44 275.392L330.267 291.651C330.267 291.651 315.16 271.758 306.773 255.78C301.973 246.86 298.13 237.455 295.307 227.724L304.533 220.723C304.533 220.723 333.627 261.912 355.44 275.392Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.44 275.392L373.893 291.932C373.893 291.932 377.533 274.27 375.573 264.464C373.613 254.658 371.667 246.535 371.667 246.535C371.667 246.535 362.987 269.514 355.44 275.392Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 252.132C328 252.132 343.387 266.147 348.413 269.794C350.147 271.037 355.413 275.392 355.413 275.392C355.413 275.392 361.147 268.712 362.4 266.989C365.76 262.219 369.96 255.499 369.96 255.499L376.627 238.679L328 252.132Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.307 227.75C295.307 227.75 317.68 273.174 334.187 295.886C350.693 318.598 356 333.134 356 333.134C356 333.134 369.707 305.385 371.387 297.263C373.067 289.14 375.293 259.708 375.293 259.708C375.293 259.708 380.053 283.756 373.333 308.472C369.347 323.195 363.021 337.179 354.6 349.888C354.6 349.888 326.067 305.332 314.32 285.158C302.573 264.985 295.307 227.75 295.307 227.75Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.893 161.244C318.893 161.244 314.893 189.995 313.627 200.817C312.36 211.638 313.36 225.88 314.96 230.623C316.56 235.366 322.853 255.165 328.12 256.221C333.387 257.276 338.92 258.064 343.133 255.686C347.347 253.308 374.733 245.132 379.2 239.654C383.667 234.177 388.413 223.034 388.413 223.034L408.693 180.55L318.893 161.244Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.933 180.242C393.933 180.242 386.04 188.419 388.667 189.728C391.293 191.037 393.147 192.106 393.147 192.106C393.147 192.106 389.147 198.706 390.253 199.761C391.36 200.817 400.52 197.65 400.52 197.65L407.627 182.34L393.933 180.242Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.187 181.752C331.882 178.903 326.273 176.662 320.467 175.072C312.373 173.108 306.8 172.841 306.52 175.633C306.463 177.737 306.845 179.83 307.64 181.779C307.64 181.779 307.64 190.436 310.147 194.35C312.653 198.265 319.627 200.777 325.2 201.03C330.773 201.284 333.84 199.628 335.52 196.835C336.667 194.912 338.187 189.06 339.067 185.56C339.248 184.805 339.159 184.01 338.816 183.314C338.472 182.618 337.896 182.065 337.187 181.752Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.693 185.386C356.257 185.22 362.818 185.794 369.253 187.096C378.08 189.167 383.64 191.638 382.587 194.484C381.614 196.562 380.22 198.413 378.493 199.922C378.493 199.922 374.253 208.352 369.907 210.917C365.56 213.482 357.533 212.52 351.973 210.048C346.413 207.577 344.24 204.437 343.973 200.897C343.787 198.465 345.16 192.012 346.04 188.192C346.23 187.368 346.702 186.637 347.375 186.127C348.047 185.616 348.877 185.359 349.72 185.399L349.693 185.386Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.187 181.752L349.693 185.386L346.013 188.178C346.013 188.178 341.08 185.974 339.08 186.495C339.08 186.495 339.613 182.807 337.187 181.752Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.733 192.547L401.547 195.62L400.52 197.65L379.427 198.706C379.427 198.706 383.467 195.62 381.733 192.547Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.88 201.338C392.88 201.338 401.573 191.051 405.253 196.328C408.933 201.605 400.52 217.169 397.627 219.28C394.733 221.391 388.933 219.013 388.933 217.169",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.88 201.338C392.88 201.338 401.573 191.051 405.253 196.328C408.933 201.605 400.52 217.169 397.627 219.28C394.733 221.391 388.933 219.013 388.933 217.169",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.533 182.514C351.533 182.514 366.92 178.853 377.307 185.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.333 172.306C328.736 172.386 331.085 173.033 333.191 174.194C335.297 175.354 337.1 176.996 338.453 178.986",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.333 194.858C336.333 194.858 326.333 214.511 325.947 216.435C325.56 218.358 334.027 220.296 337.947 220.443C341.867 220.59 341.947 218.719 341.947 218.719",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.64 230.89L335.573 232.827",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.853 104.785C337.853 104.785 322.053 141.458 320.52 142.768C318.987 144.077 281.853 148.312 278.4 148.312C274.947 148.312 286.827 156.221 331.853 167.577C376.88 178.933 408.467 186.829 422.427 187.884C436.387 188.94 455.867 189.995 452.707 188.94C449.547 187.884 426.107 174.698 422.947 172.053C420.288 169.612 417.822 166.968 415.573 164.144C415.573 164.144 420.053 125.4 415.32 120.349C410.587 115.299 365.547 98.4524 358.44 97.397C351.333 96.3415 341.333 100.256 337.853 104.785Z",
    fill: "url(#paint12_linear_322_56)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.613 133.656C385.654 134.413 387.811 134.806 389.987 134.818",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.733 124.571C399.733 124.571 361.547 104.264 362.08 113.482C362.44 119.922 371.133 127.911 379.667 132.053",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.467 126.174C325.253 133.335 322.16 140.055 320.92 142.14C325.96 145.065 334.547 149.047 349.173 153.856C382.08 164.665 415.52 164.144 415.52 164.144C415.52 164.144 416.333 157.156 416.853 148.739L377.573 141.458C360.652 138.355 344.165 133.223 328.467 126.174Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.453 132.267L334.693 139.08",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.427 107.617L337.453 132.267",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.96 101.352L348.147 105.84",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.093 380.001L409.893 370.222L423.227 212.787L538.427 222.58L537.92 228.525L539.12 228.94C539.883 229.204 540.537 229.714 540.979 230.392C541.421 231.069 541.625 231.874 541.56 232.68L537.427 281.538C537.367 282.208 537.124 282.848 536.724 283.388C536.324 283.928 535.783 284.346 535.16 284.597L533.107 285.412L525.093 380.001Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.907 339.053C377.907 339.053 402.76 303.542 404.08 302.874C405.4 302.206 430.253 298.559 431.907 298.225C433.56 297.891 451.787 303.569 451.787 303.569C451.787 303.569 453.44 306.241 451.12 307.884L448.8 309.54C449.582 311.344 450.138 313.238 450.453 315.178C450.453 316.835 448.467 319.186 448.467 319.186C448.467 319.186 449.8 323.194 448.133 324.838C446.467 326.481 432.907 329.474 431.907 329.808C430.907 330.142 422.573 337.449 422.573 337.449C422.573 337.449 434.84 335.779 438.813 335.125C442.787 334.47 445.773 335.779 444.773 338.772C443.773 341.765 440.133 342.78 437.16 343.421C434.187 344.063 416.613 349.059 416.613 349.059C416.613 349.059 402.707 360.683 395.747 362.673C388.787 364.664 375.867 366.988 375.867 366.988L377.907 339.053Z",
    fill: "#A1A1A1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.8 309.514L430.587 307.523L411.373 311.838",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.467 319.133L432.907 317.81L413.693 326.107",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.653 333.735L380.893 334.737L378.573 372.573L362.013 372.907L365.653 333.735Z",
    fill: "#A1A1A1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.573 235.486C271.573 235.486 212.613 248.766 211.573 252.426C210.533 256.087 206.667 289.594 206.667 290.917C206.667 292.239 186.787 309.848 187.787 314.163C188.787 318.478 193.747 335.726 193.747 335.726C193.747 335.726 178.507 356.648 182.147 363.288C185.787 369.928 194.413 385.185 199.707 390.836C205 396.487 209.333 398.184 215.267 396.848C221.2 395.512 365 378.585 365 378.585L369.307 333.161L271.253 325.145C271.253 325.145 273.92 307.229 274.227 303.248C274.533 299.267 268.6 290.302 262.64 282.005",
    fill: "url(#paint13_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.573 235.486C271.573 235.486 212.613 248.766 211.573 252.426C210.533 256.087 206.667 289.594 206.667 290.917C206.667 292.239 186.787 309.848 187.787 314.163C188.787 318.478 193.747 335.726 193.747 335.726C193.747 335.726 178.507 356.648 182.147 363.288C185.787 369.928 194.413 385.185 199.707 390.836C205 396.487 209.333 398.184 215.267 396.848C221.2 395.512 365 378.585 365 378.585L369.307 333.161L271.253 325.145C271.253 325.145 273.92 307.229 274.227 303.248C274.533 299.267 268.6 290.302 262.64 282.005",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.053 339.4C199.04 341.858 196.867 343.942 196.387 345.025",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.28 324.45C266.28 324.45 234.813 323.448 226.853 324.784C222.64 325.479 214.853 330.128 208.093 334.844",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.213 320.79C223.213 320.79 202.013 323.462 202.68 319.801C203.347 316.14 216.253 314.818 227.187 315.486C234.122 316.022 240.88 317.939 247.067 321.124",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.48 288.271C250.427 283.368 243.933 277.65 241.107 277.65C236.133 277.65 217.92 284.33 217.92 284.33",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.307 295.232C262.307 295.232 260.48 293.255 257.853 290.623",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.653 251.732L270.253 249.434",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32 239.481C259.32 239.481 223.88 252.092 225.533 254.083C227.187 256.074 236.467 264.771 238.787 264.37C240.24 264.156 252.2 258.358 260.947 254.043",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.427 255.74C242.427 257.383 240.507 258.732 238.12 258.732C235.733 258.732 233.813 257.396 233.813 255.74C233.813 254.083 235.747 252.747 238.12 252.747C240.493 252.747 242.427 254.083 242.427 255.74Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.867 406.427C438.867 406.427 458.733 391.157 463.373 386.187C468.013 381.217 473.64 382.179 475.64 383.515C477.64 384.851 501.467 408.738 503.453 410.729C505.44 412.72 502.12 420.696 502.12 420.696C502.12 420.696 491.453 423.368 486.88 423.368C482.957 423.129 479.072 422.462 475.293 421.377C475.293 421.377 459.72 423.368 455.747 422.045C451.773 420.722 438.867 406.427 438.867 406.427Z",
    fill: "#A1A1A1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.813 405.439C447.813 405.439 465.36 419.373 465.04 420.709C464.72 422.045 457.04 427.67 454.44 427.67C451.84 427.67 436.547 413.067 435.227 410.742C433.907 408.418 442.507 405.105 443.507 404.771",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.813 405.439C447.813 405.439 465.36 419.373 465.04 420.709C464.72 422.045 457.04 427.67 454.44 427.67C451.84 427.67 436.547 413.067 435.227 410.742C433.907 408.418 442.507 405.105 443.507 404.771",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.013 389.5C469.013 389.5 477.293 426.013 479.28 427.015C482.311 428.018 485.583 428.018 488.613 427.015C490.613 426.013 487.96 391.157 486.96 390.168C485.96 389.179 476.693 381.537 474.04 380.816C471.387 380.095 468.08 381.484 465.76 383.809",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.013 389.5C469.013 389.5 477.293 426.013 479.28 427.015C482.311 428.018 485.583 428.018 488.613 427.015C490.613 426.013 487.96 391.157 486.96 390.168C485.96 389.179 476.693 381.537 474.04 380.816C471.387 380.095 468.08 381.484 465.76 383.809",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.893 390.168C486.893 390.168 499.813 396.14 500.813 397.797C501.813 399.453 497.827 424.022 497.16 426.347C496.493 428.671 488.547 427.015 488.547 427.015L486.893 390.168Z",
    fill: "#A1A1A1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.813 397.797C500.813 397.797 512.067 401.457 511.08 407.149C510.093 412.84 504.787 427.389 502.8 428.391C500.813 429.393 497.16 426.4 497.16 426.4L500.813 397.797Z",
    fill: "#A1A1A1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.08 407.095C511.08 407.095 516.053 408.097 516.707 409.42C517.36 410.742 519.373 428.004 518.36 429.994C517.347 431.985 513.4 433.321 511.413 430.328C509.427 427.336 507.76 418.05 507.76 418.05L511.08 407.095Z",
    fill: "#A1A1A1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.467 272.747L435.267 257.904L432.453 258.318L432.2 256.595L440.053 255.432L440.307 257.156L437.64 257.557L439.84 272.466L437.467 272.747Z",
    fill: "url(#paint14_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.387 271.264C447.453 271.446 446.486 271.358 445.6 271.01C444.858 270.66 444.253 270.072 443.88 269.34C443.449 268.456 443.161 267.509 443.027 266.535L442.093 260.229C441.925 259.274 441.925 258.297 442.093 257.343C442.25 256.555 442.662 255.84 443.267 255.312C444.018 254.739 444.914 254.387 445.853 254.297C446.777 254.103 447.737 254.187 448.613 254.537C449.337 254.865 449.933 255.424 450.307 256.127C450.748 256.988 451.037 257.919 451.16 258.879L452.093 265.212C452.262 266.171 452.262 267.152 452.093 268.111C451.948 268.912 451.545 269.644 450.947 270.195C450.223 270.805 449.329 271.178 448.387 271.264ZM448.107 269.434C448.604 269.393 449.074 269.186 449.44 268.846C449.72 268.52 449.889 268.113 449.92 267.684C449.957 267.139 449.93 266.592 449.84 266.054L448.76 258.759C448.686 258.22 448.551 257.692 448.36 257.183C448.216 256.791 447.937 256.464 447.573 256.261C447.125 256.047 446.618 255.99 446.133 256.1C445.64 256.149 445.174 256.349 444.8 256.675C444.511 256.98 444.336 257.377 444.307 257.797C444.27 258.337 444.297 258.88 444.387 259.414L445.453 266.708C445.525 267.249 445.664 267.778 445.867 268.285C446.006 268.696 446.291 269.043 446.667 269.26C447.106 269.5 447.615 269.58 448.107 269.487V269.434Z",
    fill: "url(#paint15_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.16 270.128L452.707 253.482L456.827 252.867C457.651 252.707 458.503 252.772 459.293 253.054C459.933 253.326 460.47 253.794 460.827 254.39C461.24 255.138 461.503 255.959 461.6 256.808C461.739 257.591 461.698 258.395 461.48 259.16C461.28 259.83 460.88 260.422 460.333 260.857C459.696 261.326 458.946 261.621 458.16 261.712L456.333 261.979L457.48 269.728L455.16 270.128ZM456.093 260.376L457.16 260.215C457.695 260.154 458.215 259.995 458.693 259.748C458.868 259.654 459.02 259.524 459.142 259.368C459.264 259.212 459.352 259.031 459.4 258.839C459.512 258.302 459.512 257.747 459.4 257.209C459.324 256.593 459.176 255.988 458.96 255.406C458.883 255.219 458.766 255.053 458.615 254.919C458.465 254.785 458.287 254.686 458.093 254.631C457.512 254.515 456.914 254.515 456.333 254.631L455.253 254.791L456.093 260.376Z",
    fill: "url(#paint16_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.64 267.577C472.805 267.729 471.944 267.636 471.16 267.309C470.46 266.989 469.871 266.469 469.467 265.813C468.997 265.072 468.675 264.246 468.52 263.382L470.48 262.513C470.607 263.085 470.786 263.644 471.013 264.183C471.208 264.666 471.52 265.093 471.92 265.426C472.127 265.576 472.363 265.682 472.613 265.737C472.863 265.793 473.122 265.796 473.373 265.746C473.634 265.733 473.888 265.663 474.118 265.54C474.349 265.418 474.549 265.247 474.707 265.038C474.985 264.583 475.076 264.037 474.96 263.515C474.896 262.865 474.619 262.255 474.173 261.778C473.72 261.329 473.219 260.931 472.68 260.589L469.533 258.532C468.964 258.195 468.473 257.739 468.093 257.196C467.711 256.57 467.47 255.868 467.387 255.138C467.279 254.625 467.28 254.096 467.387 253.583C467.495 253.07 467.709 252.585 468.013 252.159C468.681 251.351 469.639 250.838 470.68 250.73C471.262 250.623 471.858 250.623 472.44 250.73C472.927 250.816 473.385 251.023 473.773 251.331C474.185 251.67 474.525 252.088 474.773 252.56C475.081 253.141 475.31 253.762 475.453 254.404L473.56 255.219C473.449 254.716 473.292 254.224 473.093 253.749C472.926 253.339 472.643 252.987 472.28 252.734C471.876 252.504 471.404 252.424 470.947 252.507C470.702 252.529 470.464 252.599 470.247 252.714C470.03 252.829 469.837 252.985 469.68 253.175C469.535 253.382 469.435 253.618 469.387 253.866C469.338 254.115 469.343 254.371 469.4 254.617C469.441 255.05 469.592 255.464 469.84 255.82C470.109 256.173 470.439 256.476 470.813 256.715L473.987 258.759C474.719 259.232 475.379 259.808 475.947 260.469C476.569 261.232 476.954 262.161 477.053 263.141C477.192 263.875 477.127 264.633 476.867 265.332C476.62 265.962 476.199 266.509 475.653 266.909C475.045 267.29 474.355 267.519 473.64 267.577Z",
    fill: "url(#paint17_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.4 266.535L476.933 249.888L483.373 248.926L483.627 250.663L479.507 251.264L480.32 256.782L483.667 256.274L483.907 257.917L480.56 258.425L481.467 264.517L485.627 263.903L485.88 265.573L479.4 266.535Z",
    fill: "url(#paint18_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 264.865C491.038 265.063 490.037 264.946 489.147 264.531C488.42 264.123 487.844 263.49 487.507 262.727C487.111 261.88 486.842 260.98 486.707 260.055L485.84 254.177C485.695 253.184 485.695 252.176 485.84 251.184C485.939 250.366 486.316 249.606 486.907 249.033C487.662 248.402 488.593 248.019 489.573 247.937C490.426 247.771 491.307 247.845 492.12 248.151C492.786 248.445 493.335 248.953 493.68 249.594C494.085 250.378 494.347 251.229 494.453 252.106L494.653 253.442L492.453 253.762L492.28 252.587C492.209 252.04 492.098 251.5 491.947 250.97C491.858 250.557 491.621 250.191 491.28 249.941C490.844 249.703 490.334 249.641 489.853 249.768C489.608 249.763 489.364 249.81 489.137 249.906C488.911 250.002 488.708 250.145 488.54 250.326C488.373 250.506 488.245 250.72 488.166 250.953C488.087 251.186 488.058 251.433 488.08 251.678C488.072 252.286 488.112 252.894 488.2 253.495L489.187 260.082C489.261 260.752 489.427 261.408 489.68 262.032C489.828 262.437 490.123 262.771 490.507 262.967C490.93 263.138 491.394 263.18 491.84 263.088C492.093 263.083 492.342 263.026 492.571 262.921C492.801 262.815 493.006 262.662 493.173 262.473C493.418 262.107 493.535 261.67 493.507 261.231C493.498 260.649 493.449 260.069 493.36 259.494L493.173 258.265L495.373 257.931L495.547 259.173C495.687 260.058 495.687 260.96 495.547 261.845C495.447 262.607 495.095 263.313 494.547 263.849C493.827 264.451 492.935 264.806 492 264.865Z",
    fill: "url(#paint19_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.293 263.729L495.84 247.082L499.187 246.588C500.116 246.411 501.071 246.411 502 246.588C502.726 246.748 503.37 247.165 503.813 247.764C504.307 248.504 504.618 249.351 504.72 250.235C504.792 250.83 504.792 251.431 504.72 252.026C504.673 252.531 504.513 253.019 504.253 253.455C504 253.878 503.63 254.217 503.187 254.43L506.773 262.446L504.533 262.78L501.213 255.299L499.413 255.566L500.56 263.368L498.293 263.729ZM499.213 253.909L500.093 253.776C500.64 253.721 501.17 253.557 501.653 253.295C502.031 253.083 502.313 252.734 502.44 252.32C502.565 251.756 502.565 251.173 502.44 250.609C502.394 249.862 502.098 249.151 501.6 248.592C501.277 248.379 500.912 248.239 500.53 248.181C500.148 248.123 499.758 248.15 499.387 248.258L498.36 248.405L499.213 253.909Z",
    fill: "url(#paint20_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.933 262.152L506.48 245.506L512.92 244.557L513.173 246.281L509.053 246.882L509.867 252.4L513.213 251.892L513.453 253.535L510.107 254.043L511.013 260.135L515.173 259.521L515.413 261.191L508.933 262.152Z",
    fill: "url(#paint21_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.107 260.643L516.907 245.72L514.093 246.134L513.84 244.41L521.693 243.248L521.947 244.972L519.28 245.386L521.48 260.295L519.107 260.643Z",
    fill: "url(#paint22_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.187 278.612C433.688 278.61 432.24 278.069 431.105 277.089C429.97 276.108 429.223 274.753 429 273.268L426.6 255.9C426.376 254.255 426.811 252.588 427.81 251.263C428.81 249.939 430.292 249.065 431.933 248.833L486.667 241.177L486.867 242.58L432.12 250.209C431.491 250.297 430.885 250.509 430.337 250.832C429.789 251.156 429.31 251.584 428.928 252.092C428.545 252.601 428.266 253.18 428.107 253.797C427.948 254.414 427.912 255.056 428 255.686L430.4 273.054C430.579 274.329 431.254 275.481 432.279 276.257C433.304 277.033 434.594 277.371 435.867 277.196L447.387 275.593L447.573 276.929L436.053 278.532C435.767 278.578 435.477 278.605 435.187 278.612Z",
    fill: "url(#paint23_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.893 275.927L454.707 274.524L523.373 264.958C524.002 264.871 524.608 264.661 525.156 264.339C525.703 264.017 526.182 263.59 526.565 263.083C526.948 262.575 527.227 261.997 527.386 261.381C527.545 260.765 527.582 260.124 527.493 259.494L525.093 242.126C525.005 241.495 524.794 240.888 524.471 240.339C524.148 239.79 523.721 239.311 523.213 238.927C522.706 238.544 522.128 238.264 521.512 238.105C520.897 237.945 520.256 237.909 519.627 237.998L491.827 241.872L491.627 240.536L519.44 236.662C520.254 236.547 521.082 236.594 521.877 236.801C522.672 237.007 523.419 237.369 524.075 237.866C524.73 238.362 525.281 238.984 525.696 239.694C526.111 240.404 526.382 241.19 526.493 242.006L528.893 259.374C529.121 261.019 528.688 262.689 527.687 264.014C526.687 265.339 525.203 266.212 523.56 266.441L454.893 275.927Z",
    fill: "url(#paint24_linear_322_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.667 389.513H369.013V539.466H429.667V389.513Z",
    fill: "#4F4F4F",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.56 427.282H377.533V537.208H566.56V427.282Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.4 389.513H357.053V539.466H371.4V389.513Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.626 378.117H536.146V551.156H729.626V378.117Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.4 378.117H718.013V551.156H776.4V378.117Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.47998 551.143H807.56",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.68 551.143H85.44",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.307 304.023L94.6668 299.08H94.5868C94.1414 298.865 93.664 298.725 93.1734 298.665C92.2987 298.386 91.3655 298.346 90.4701 298.549C89.5747 298.752 88.7496 299.19 88.0797 299.819C87.4099 300.448 86.9197 301.245 86.6596 302.127C86.3995 303.009 86.3789 303.945 86.6001 304.838L20.0001 438.585C18.1642 437.943 16.2124 437.702 14.2759 437.879C12.3395 438.057 10.4635 438.648 8.77405 439.612C7.08465 440.577 5.6211 441.893 4.48193 443.472C3.34275 445.051 2.55439 446.856 2.16991 448.766C1.78542 450.676 1.81373 452.646 2.25293 454.544C2.69214 456.443 3.53205 458.224 4.71612 459.77C5.90019 461.315 7.40095 462.589 9.11737 463.504C10.8338 464.42 12.7261 464.956 14.6668 465.078L61.4134 546.146H72.0801L23.7468 462.312C26.4034 460.319 28.2375 457.418 28.9011 454.16C29.5647 450.902 29.0116 447.513 27.3468 444.637L94.3068 309.874L107.2 313.882C108.51 314.295 109.93 314.17 111.148 313.533C112.366 312.897 113.281 311.802 113.693 310.489C114.105 309.176 113.98 307.753 113.345 306.533C112.71 305.313 111.617 304.395 110.307 303.983V304.023Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.627 540.134H13.4668V551.41H149.627V540.134Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.826 287.891L99.0962 323.733L134.867 329.474L140.596 293.632L104.826 287.891Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.653 280.897L164.187 352.56L131.293 328.899L137.027 293.068L175.653 280.897Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_322_56",
    x1: 137.761,
    y1: -0.252581,
    x2: 541.664,
    y2: 31.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_322_56",
    x1: 612.932,
    y1: 192.6,
    x2: 626.885,
    y2: 193.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_322_56",
    x1: 642.749,
    y1: 155.389,
    x2: 665.715,
    y2: 156.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_322_56",
    x1: 689.881,
    y1: 166.477,
    x2: 711.964,
    y2: 167.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_322_56",
    x1: 691.131,
    y1: 259.374,
    x2: 706.065,
    y2: 260.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_322_56",
    x1: 637.474,
    y1: 270.987,
    x2: 651.841,
    y2: 272.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_322_56",
    x1: 612.606,
    y1: 243.492,
    x2: 631.693,
    y2: 245.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_322_56",
    x1: 687.797,
    y1: 139,
    x2: 707.987,
    y2: 142.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_322_56",
    x1: 720.423,
    y1: 224.34,
    x2: 739.511,
    y2: 226.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_322_56",
    x1: 220.309,
    y1: 230.324,
    x2: 351.229,
    y2: 236.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_322_56",
    x1: 283.898,
    y1: 217.664,
    x2: 330.1,
    y2: 219.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_322_56",
    x1: 346.376,
    y1: 233.923,
    x2: 385.912,
    y2: 235.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_322_56",
    x1: 298.777,
    y1: 97.2233,
    x2: 397.96,
    y2: 110.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_322_56",
    x1: 204.017,
    y1: 235.486,
    x2: 311.4,
    y2: 243.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_322_56",
    x1: 433.169,
    y1: 255.432,
    x2: 437.83,
    y2: 255.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_322_56",
    x1: 443.192,
    y1: 254.195,
    x2: 449.084,
    y2: 254.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_322_56",
    x1: 453.779,
    y1: 252.782,
    x2: 458.938,
    y2: 252.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_322_56",
    x1: 468.48,
    y1: 250.649,
    x2: 474.122,
    y2: 250.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_322_56",
    x1: 478.002,
    y1: 248.926,
    x2: 483.146,
    y2: 249.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_322_56",
    x1: 486.917,
    y1: 247.851,
    x2: 492.618,
    y2: 248.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_322_56",
    x1: 497.147,
    y1: 246.455,
    x2: 503.428,
    y2: 246.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_322_56",
    x1: 507.547,
    y1: 244.557,
    x2: 512.683,
    y2: 244.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_322_56",
    x1: 514.809,
    y1: 243.248,
    x2: 519.47,
    y2: 243.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_322_56",
    x1: 433.751,
    y1: 241.177,
    x2: 468.06,
    y2: 244.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_322_56",
    x1: 463.579,
    y1: 236.6,
    x2: 505.618,
    y2: 242.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3863FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C38FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 808,
    height: 609,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroRight);
export default __webpack_public_path__ + "static/media/hero-right.687af6535c4f1015bd6b6ac963f2c5c5.svg";
export { ForwardRef as ReactComponent };